import { atom } from 'recoil';

export const refreshCoveragePackagesAtom = atom<object>({
    key: 'refreshCoveragePackagesAtom',
    default: {}
});
